import React, { useState } from "react"
import { Grid2, MenuItem, Select, Tab, Tabs } from "@mui/material"
import {
    ArcElement,
    BarElement,
    CategoryScale,
    Chart as ChartJS,
    Filler,
    Legend,
    LinearScale,
    LineElement,
    PointElement,
    TimeScale,
    Title,
    Tooltip,
} from "chart.js"
import "chartjs-adapter-date-fns"
import { SessionsByHour } from "routes/sfg20-admin/plugins/system-info/activity-tab/tiles/sessions-by-hour"
import { NavigateByHour } from "routes/sfg20-admin/plugins/system-info/activity-tab/tiles/navigate-by-hour"
import { LoginsByHour } from "routes/sfg20-admin/plugins/system-info/activity-tab/tiles/logins-by-hour"
import { BrowserStats } from "routes/sfg20-admin/plugins/system-info/activity-tab/tiles/browsers"
import { OsStats } from "routes/sfg20-admin/plugins/system-info/activity-tab/tiles/os"
import { OsAndBrowser } from "routes/sfg20-admin/plugins/system-info/activity-tab/tiles/osAndBrowser"
import { FileNotFound } from "routes/sfg20-admin/plugins/system-info/activity-tab/tiles/404"
import { Events } from "routes/sfg20-admin/plugins/system-info/activity-tab/tiles/events"

ChartJS.register(
    CategoryScale,
    LinearScale,
    TimeScale,
    BarElement,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    ArcElement,
    Filler
)

function StatsAnalysis() {
    const [reportDuration, setReportDuration] = useState(1) // default to 'Last week'
    const [granularity, setGranularity] = useState("hour") // default to 'Last week'
    const handleDurationChange = (event) => {
        setReportDuration(event.target.value)
    }
    const handleGranularityChange = (event) => {
        setGranularity(event.target.value)
    }
    return (
        <>
            Reporting on data for the
            <Select
                labelId="report-duration-label"
                value={reportDuration}
                label="Report Range"
                onChange={handleDurationChange}
                variant="outlined"
                sx={{ paddingLeft: "5px" }}
                data-cy="activity-report-duration-select"
            >
                <MenuItem value={1}>Last Day</MenuItem>
                <MenuItem value={3}>Last 3 Days</MenuItem>
                <MenuItem value={7}>Last Week</MenuItem>
                <MenuItem value={30}>Last Month</MenuItem>
                <MenuItem value={90}>Last 3 Months</MenuItem>
                <MenuItem value={180}>Last 6 Months</MenuItem>
                <MenuItem value={365}>Last 12 Months</MenuItem>
            </Select>
            by
            <Select
                labelId="report-granularity-label"
                value={granularity}
                label="Granularity"
                onChange={handleGranularityChange}
                variant="outlined"
                sx={{ paddingLeft: "5px" }}
                data-cy="activity-granularity-select"
            >
                <MenuItem value={"hour"}>Hour</MenuItem>
                <MenuItem value={"day"}>Day</MenuItem>
                <MenuItem value={"month"}>Month</MenuItem>
            </Select>
            <StatsAnalysisWithDate reportDuration={reportDuration} granularity={granularity} />
        </>
    )
}

function StatsAnalysisWithDate({ reportDuration, granularity }) {
    const [currentTab, setCurrentTab] = useState(0)

    // const apiResponse = getAnalysis.useResults(reportDuration)

    function handleChange(event, newValue) {
        setCurrentTab(newValue)
    }
    //    const data = apiResponse?.results
    //    if (!data) return null

    return (
        <>
            <Tabs variant="scrollable" scrollButtons={false} onChange={handleChange} value={currentTab}>
                <Tab label="Sessions"></Tab>
                <Tab label="Logins" />
                <Tab label="Navigation" />
                <Tab label="Platforms" />
                <Tab label="Diagnostics" />
            </Tabs>
            <Grid2 container spacing={3} justifyContent="center" alignItems="stretch" mt={4} sx={{ width: "100%" }}>
                {currentTab === 0 && <SessionsByHour reportDuration={reportDuration} granularity={granularity} />}
                {currentTab === 1 && <LoginsByHour reportDuration={reportDuration} granularity={granularity} />}

                {currentTab === 2 && <NavigateByHour reportDuration={reportDuration} granularity={granularity} />}

                {currentTab === 3 && (
                    <>
                        <BrowserStats reportDuration={reportDuration} granularity={granularity} />
                        <OsStats reportDuration={reportDuration} granularity={granularity} />
                        <OsAndBrowser reportDuration={reportDuration} granularity={granularity} />
                    </>
                )}

                {currentTab === 4 && (
                    <>
                        <Events reportDuration={reportDuration} />
                        <FileNotFound reportDuration={reportDuration} />
                    </>
                )}
            </Grid2>
        </>
    )
}

export default StatsAnalysis
